import React from 'react'

const CheckmarkOutline = props => (
  <svg
    viewBox='0 0 20 20'
    width={props.width || '20px'}
    height={props.height || '20px'}
  >
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g fill={props.color || '#000'} fillRule='nonzero'>
        <path d='M10,0 C4.4771525,0 2.22044605e-15,4.4771525 2.22044605e-15,10 C2.22044605e-15,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C20,7.3478351 18.9464316,4.80429597 17.0710678,2.92893219 C15.195704,1.0535684 12.6521649,0 10,0 Z M10,18 C5.581722,18 2,14.418278 2,10 C2,5.581722 5.581722,2 10,2 C14.418278,2 18,5.581722 18,10 C18,12.1217319 17.1571453,14.1565632 15.6568542,15.6568542 C14.1565632,17.1571453 12.1217319,18 10,18 Z' />
        <path d='M12.7,6.39 L8.92,11.39 L7.29,9.28 C6.95034488,8.84369505 6.32130495,8.76534488 5.885,9.105 C5.44869505,9.44465512 5.37034488,10.073695 5.71,10.51 L8.14,13.62 C8.33082212,13.861492 8.62221965,14.001658 8.93,14.0000145 C9.23949665,13.9992561 9.53120739,13.855247 9.72,13.61 L14.29,7.61 C14.6268937,7.1681722 14.5418278,6.5368937 14.1,6.2 C13.6581722,5.8631063 13.0268937,5.9481722 12.69,6.39 L12.7,6.39 Z' />
      </g>
    </g>
  </svg>
)

export default CheckmarkOutline
